module.exports = __webpack_public_path__ + "static/img/banner1.7118da90.png";